import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../../css/common.css'

import SouthDronographer from './articles/south_dronographer';
import FelixTheCat from './articles/felix_the_cat';
import Shimakaze from './articles/shimakaze';
import FlickrFlow_story from './articles/flickrFlow_story';
import Cefalofotografo from './articles/cefalofotografo';


let online_es = (<div>
    Este es un listado de mis últimos proyectos sin ningún orden en particular. Se trata de proyectos de todo tipo, pero centrado en lo que más me gusta: construir cosas.
</div>);
let online_en = (<div>
    This is a list of my latests projects in no particular order. These are all kind of projects, but centered about what I like best: building things. 
</div>);

let online = online_es;

export function Projects(props){

    const lang = props.lang;
    const location = useLocation();

    switch(lang){
        case "en":
            online = online_en;
            break;
        case "es":
        default:
            online = online_es;
            break;
    }

    useEffect(() => {
        if (location.hash) {
            const target = document.getElementById(location.hash.slice(1));
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [location]);

    let text_structure = (
        <div>
            <p>{online}</p>
            <div className='medDiv' id="cefalofotografo"><Cefalofotografo lang={lang}/></div>
            <p></p>
            <div className='medDiv' id="flickrFlow"><FlickrFlow_story lang={lang}/></div>
            <p></p>
            <div className='medDiv' id="shimakaze"><Shimakaze lang={lang}/></div>
            <p></p>
            <div className='medDiv' id="felixTheCat"><FelixTheCat lang={lang}/></div>
            <p></p>
            <div className='medDiv' id="southDronographer"><SouthDronographer lang={lang}/></div>
            <p></p>
        </div>
    );

    return(<div>{text_structure}</div>);
}